const paths = { editPartner: '/partner/edit', webServiceRates: '/partner/rates' };

export default paths;
